
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    getEdit: { api: 'T0060SeminarCalendarService.M20801_getEdit'},
    doDelete: { api: 'T0060SeminarCalendarService.M20801_doDelete'},
    doBrowse: { api: 'T0060SeminarCalendarService.M20801_doBrowse'},
  },
}

const module = {
  state: {
    PageConst,
    dropdownList: {
      centers: []
    },
    defaultDoBrowse: {
      searchInfo: {
        showPrevious: false
      },
      orderBy: {},
      doBrowseStatus: 'init',
      errorMessage: {},
    },
  },

  getters: {},

  mutations: {},

  actions: {
    async M20801_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async doSave ({ state }, payload) {
      return await $this.$api.postData({
        data: [{ api: 'T0060SeminarCalendarService.M20801_doSave', input: payload }]
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
